import React from 'react'
import { InputText } from 'primereact/inputtext'
import { useTranslation } from 'react-i18next'

import Card from '_shared/svg/Card'
import './style.js'
import { classNames } from 'primereact/utils'
import StyleWrapper from './style.js'
import i18n from 'translations/index.js'

function LeadInput({
  name = '',
  value = '',
  defaultValue = '',
  onChange = () => { },
  label = '',
  translation = true,
  error = '',
  maxLength,
  placeholder = '',
  leftIcon = true,
  icon: Icon = Card,
  iconColor = '',
  number = false,
  padding = 0,
  margin = 0,
  unit = 0
}) {
  const { t } = useTranslation()
  return (
    <div style={{ padding, margin }}>
      <StyleWrapper>
        <div className={`common_input ${leftIcon ? "" : "common_input_noleftIcon"} ${i18n.language ==='ar' ? " ar" : ""}`}>
          <span
            className={classNames({
              "p-float-label": true,
              "p-invalid": Boolean(error.length),
            })}
          >
            {/* {leftIcon && <Icon fill={iconColor} />} */}
            <InputText
              name={name}
              value={value}
              defaultValue={defaultValue}
              maxLength={maxLength}
              onChange={(e) => onChange({ ...e, number })}
              id="normal_input"
              placeholder={placeholder}
              className={unit == 1 && "isEnglish"}
            />
            {unit == 1 && <span className="p-inputgroup-addon">SAR</span>}

            <label htmlFor="normal_input">{translation ? t(label) : label}</label>
          </span>
        </div>
        {Boolean(error.length) && (
          <small className="p-error block">{translation ? t(error) : error}</small>
        )}
      </StyleWrapper>
    </div>
  );
}

export default LeadInput